import z from 'zod';
const multipleEmailRegex = /^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$/;
export const string = z.string().max(1024);
export const uuid = z.string().uuid();
export const datetime = z.string().datetime();
export const url = z.string().url();
export const multipleEmailString = z.string().regex(multipleEmailRegex);
export const longString = z.string().max(4096);
export const procedureString = longString.nullable();
// Use this instead of z.object().passthrough() due to issues with zod types.
// Output type of the passthrough() schema is not a assignable to the input type, which makes passing dtos which use
// this down to the service cause type errors.
export const objectPassthrough = (input) => {
    const result = z.object(input);
    return result.passthrough();
};
